<!-- 自主报考，上传文件页面 -->
<template>
  <div id="app_p">
    <van-form
     @submit="owninfonext"
     scroll-to-error
     validate-first
     >
    <input type="file" v-show="false" @change="input1change" ref="fileName1" />
    <input type="file" v-show="false" @change="input2change" ref="fileName2" />
    <input type="file" v-show="false" @change="input3change" ref="fileName3" />
    <input type="file" v-show="false" @change="input4change" ref="fileName4" />
    <input type="file" v-show="false" @change="input5change" ref="fileName5" />
    <input type="file" v-show="false" @change="input6change" ref="fileName6" />
    <input type="file" v-show="false" @change="input7change" ref="fileName7" />
    <!-- <input type="file" v-show="false" @change="input6change" ref="fileName6" />     原来的6-->  
    <!-- 步骤条 -->
    <van-steps :active="active" active-icon="success" active-color="#38f">
      <van-step>预约时间</van-step>
      <van-step>个人信息</van-step>
      <van-step>上传文件</van-step>
    </van-steps>
    <div class="filenav">预约信息</div>
    <div class="own_contain">
        <!-- 预约条件 -->
        <div class="own_name">预约条件<span>*</span></div>
            <TestInput
              readonly
              class="select_container"
              :rtest="acceptanceHint"
              :placeholder="'请选择申报条件'"
              :rules="[{required:true}]"
              @codeclick="acceptanceHandler"
            ></TestInput>
        
        <van-popup
          position="bottom"
          round
          :style="{ height: '50%' }"
          v-model="acceptanceShow"
        >
          <van-picker
            title="请选择申报条件"
            show-toolbar
            :columns="acceptanceOption"
            @confirm="acceptanceConfirm"
            @cancel="acceptanceCancel"
            @change="acceptanceChange"
          />
        </van-popup>

      <!--文化程度 -->
      <div class="own_name">文化程度<span>*</span></div>
            <TestInput
              readonly
              class="select_container"
              :rtest="examRecordHint"
              :placeholder="'请选择文化程度'"
              :rules="[{ required: true }]"
              @codeclick="examRecordHandler"
            ></TestInput>
      
      <van-popup
        position="bottom"
        round
        :style="{ height: '50%' }"
        v-model="examRecordShow"
      >
        <van-picker
          title="文化程度"
          show-toolbar
          :columns="examRecordOption"
          @confirm="examRecordConfirm"
          @cancel="examRecordCancel"
          @change="examRecordChange"
        />
      </van-popup>
        <!-- 毕业时间 -->
      <div class="own_name">毕业时间<span>*</span></div>
            <TestInput
              readonly
              class="select_container"
              :rtest="examGetTimeHint"
              :placeholder="'请选择毕业时间'"
              :rules="[{ required: true }]"
              @codeclick="examGetTimeHandler"
            ></TestInput>
      
       <van-popup
        position="bottom"
        round
        :style="{ height: '50%' }"
        v-model="examGetTimeShow"
      >
        <van-datetime-picker
          v-model="examGetTimecurrentDate"
          type="date"
          title="选择年月日"
          :min-date="examGetTimeminDate"
          :max-date="examGetTimemaxDate"
          @confirm="examGetTimeConfirm"
          @cancel="examGetTimeCancel"
          @change="examGetTimeChange"
        />
      </van-popup>
      <!-- 毕业学校* -->
          <div class="own_name">毕业学校<span>*</span></div>
          <van-field
            type="text"
            class="input-field"
            v-model="SchoolTagHint"
            @input="SchoolTagHandler"
            placeholder="请输入毕业学校"
            :rules="[{ required: true,  }]"
          />
      <!-- 上传毕业证书* -->
      <div class="filetext">上传毕业证书<span>*</span></div>
      <div class="filetext2">(扫描件PDF格式：小于1M，以身份证号命名)</div>
      <div class="filetext3">
        <file-box style="margin-right:auto" @bindup="drag1" headert="毕业证书" :mainup="upname1"></file-box>
        <file-box-example
          headert="示例"
          imgName="certificate"
        ></file-box-example>
      </div>
        <!-- 上传社保记录* -->
      <div class="filetext">
        上传社保记录&nbsp;&nbsp;<van-icon
          class="fileicon"
          @click="socalinfo"
          name="info-o"
        />
      </div>
      <div class="filetext2">(扫描件PDF格式：小于1M，以身份证号命名)</div>
      <div class="filetext3">
        <file-box style="margin-right:auto" @bindup="drag2" headert="社保记录" :mainup="upname2"></file-box>
        <file-box-example
          headert="示例"
          imgName="social"
        ></file-box-example>

      </div>
        <!-- 上传工作证明* -->
      <div class="filetext">上传工作经验及证明文件<span>*</span></div>
      <div class="filetext2">(扫描件PDF格式：小于1M，以身份证号命名)</div>
      <div class="filetext3">
        <file-box style="margin-right:auto" @bindup="drag3" headert="工作证明" :mainup="upname3"></file-box>
        <file-box-example
            headert="示例"
            imgName="experience"
          ></file-box-example>

      </div>
        <!-- 上传身份证(正反面)* -->
      <div class="filetext">上传身份证(正反面)<span>*</span></div>
      <div class="filetext2">(扫描件PDF格式：扫描放在一张A4纸上，小于1M，以身份证号命名)</div>
      <div class="filetext3">
        <file-box
          @bindup="drag4"
          headert="身份证（正反面）"
          :mainup="upname4"
          style="margin-right:12px"
        ></file-box>
        <file-box-example
          headert="示例"
          imgName="idCard"
        ></file-box-example>
        
      </div>
      <!--上传本人证件照*  -->
      <div class="filetext">上传本人证件照<span>*</span></div>
      <div class="filetext2">
        (2寸白底照:3.5cm*5.3cm。电子版jpg格式：像素306*378， 小于200K，以身份证号命名)
      </div>
      <div class="filetext3">
        <file-box style="margin-right:auto" @bindup="drag5" headert="证件照" :mainup="upname5"></file-box>
        <file-box-example
          headert="示例"
          imgName="personCard"
        ></file-box-example>
      </div>
      <!--上传报名申报表**  -->
       <div class="filetext">上传报名申报表<span>*</span></div>
      <div class="filetext2">
        (扫描件PDF格式：小于1M，以身份证号命名）
      </div>
      <div class="filetext3">
        <file-box style="margin-right:auto" @bindup="drag6" headert="报名申报表" :mainup="upname6"></file-box>
        <file-box-example
          headert="示例"
          imgName="declare"
        ></file-box-example>
      </div> 
      <!--上传学信网验证报告*  -->
       <div class="filetext">上传学信网验证报告<span>*</span></div>
      <div class="filetext2">
        (扫描件PDF格式：小于1M，以身份证号命名）
      </div>
      <div class="filetext3">
        <file-box style="margin-right:auto" @bindup="drag7" headert="学信网验证报告" :mainup="upname7"></file-box>
        <file-box-example
          headert="示例"
          imgName="xuexin"
        ></file-box-example>
      </div> 
      <!-- 证书邮件地址* -->
      <div class="own_name">证书邮件地址<span>*</span></div>
      <van-field
        class="input-field"
        v-model="examCertificateHint"
        @input="examCertificateChange"
        placeholder="输入邮寄地址"
        :rules="[{ required: true, }]"
      />
      <!-- 报名备注* -->
      <div class="own_name">报名备注</div>
      <!-- <input-box v-model="examCertificateHint" placeholder="请输入邮寄地址*">
      </input-box> -->
      <van-field
        @input="remarkChange"
        class="input-field"
        v-model="remarkHint"
        placeholder="输入报名备注"
        :rules="[{ required: false, }]"
      />
    </div>
    <div style="padding:10px 16px;">
    <van-button  block type="info" native-type="submit">提交报名</van-button>
  </div>
    </van-form>
  </div>
</template>
<script>
import fileBox from "@/components/filebox.vue";
import fileBoxExample from '@/view/reserve/fileUploadExample.vue'
import ArticleItem from "@/components/article-item/index.vue";
import TestInput from "@/components/choosec";
import inputBox from "@/components/input.vue";
import { Dialog,Notify } from 'vant';
import datetime from "../../utils/datetime.js";
export default {
  name: "App",
  components: {
    fileBoxExample,
    TestInput,
    ArticleItem,
    inputBox,
    fileBox,
  },
  data() {
    return {
      upname1: "", //毕业证书
      upname2: "",//社保记录
      upname3: "",//工作证明
      upname4: "",//身份证正反面
      upname5: "",//本人证件照
      upname6: "",//报名申报表
      upname7: "",//学信网证件
      bgColor: "#F5F5F5",
      lineColor: "#000000",
      resultImg: "",
      isCrop: false,
      // examown: "请选择专业",
          //申报条件
      acceptanceHint:"",  
      acceptanceOption: ['14412-健康管理师三级-其他'],
      acceptanceShow:false,
          //文化程度
      examRecordHint:"",  
      examRecordOption: [ "博士","硕士", "大学","大专","中专", "职高" ,"技校" ,"高中" ,"初中" ,"小学" ,"其他" ,],
      examRecordShow:false,
          //毕业时间
      examGetTimeHint:"",  
      examGetTimeOption: '',
      examGetTimeShow:false,
      examGetTimeminDate: new Date(1970, 1, 1),
      examGetTimemaxDate: new Date(),
      examGetTimecurrentDate: new Date(),
      //毕业学校
      SchoolTagHint:'',
      //证书邮寄地址
      examCertificateHint:'',
      //报名备注
      remarkHint:'',
      studentnamepdf: "",
      socialpdf: "",
      boxidentenfypdf: "",
      cardpdf: "",
      fromdata: null,
      active: 2,
      record: null,
      career: null,
      signupDetails: {},  //驳回后的上传文件页面容器
      diplomaShow:false,//毕业证
      socialSecurityShow:false ,//社保记录
      workCertificateShow:false , //工作证明
      cardpositiveShow:false,//身份证正反面
      examIdentificationImgShow:false,//证件照
      registrationFormShow:false,//申报表
      xuexinelectronicShow:false,//学信网证件照
      
    };
  },
  created() {
    if (this.$route.query.ExamOrder != null) {
      this.acceptanceHint = this.$route.query.ExamOrder.examCareer;  //申报条件
      this.examtest = this.$route.query.ExamOrder.examRecord;
      this.examGetTimeHint = this.$route.query.ExamOrder.examGetTime;  //毕业时间
      this.examCertificateHint = this.$route.query.ExamOrder.examCertificate; //邮寄地址
      console.log( this.$route.query.ExamOrder)
    }
    if (this.$route.query.examOrderId) {
      this.fetchSignupDetails();
    }
  },
 
  methods: {
    //被驳回后的上传文件页面
    fetchSignupDetails: function() {
      var  params={
        examOrderId:this.$route.query.examOrderId
      }
      return new Promise(resolve => {
        this.$http.post(`ExamOrder/ExamOrderShowOne`,params).then(res => {
          if (res.data.success && res.data.data.list.acceptance!=null) {
            this.signupDetails = res.data.data.list;
            this.examRecordHint = this.signupDetails.examRecord;
            this.examGetTimeHint = this.signupDetails.examGetTime;
            this.acceptanceHint=this.signupDetails.acceptance
            this.examCertificateHint = this.signupDetails.examCertificate;
            this.SchoolTagHint=this.signupDetails.schoolTag;
            this.upname1=this.signupDetails.diploma;
            this.upname2=this.signupDetails.socialSecurity;
            this.upname3=this.signupDetails.certificate;
            this.upname4=this.signupDetails.cardpositive;
            this.upname5=this.signupDetails.examIdentificationImg;
            this.upname6=this.signupDetails.registrationForm;
            this.upname7=this.signupDetails.xuexinelectronic;
            this.remarkHint=this.signupDetails.remark;
            resolve();
          }
        });
      })
    },
    //申报条件函数
    acceptanceHandler() {
      this.acceptanceShow = true;
    },
    acceptanceConfirm(value, index) {
      this.acceptanceHint = value
      this.acceptanceShow = false;
    },
    acceptanceChange(picker, value, index) {
      console.log(picker, value, index);
    },
    acceptanceCancel() {
      this.acceptanceShow = false;
    },
    //文化程度函数
    examRecordHandler() {
      this.examRecordShow = true;
    },
    examRecordConfirm(value, index) {
      this.examRecordHint = value
      this.examRecordShow = false;
    },
    examRecordChange(picker, value, index) {
      console.log(picker, value, index);
    },
    examRecordCancel() {
      this.examRecordShow = false;
    },
    //毕业时间
    examGetTimeHandler() {
      this.examGetTimeShow = true;
    },
    examGetTimeConfirm(value, index) {
      this.examGetTimeHint = datetime(value)
      this.examGetTimeShow = false;
    },
    examGetTimeChange(picker, value, index) {
      console.log(picker, value, index);
    },
    examGetTimeCancel() {
      this.examGetTimeShow = false;
    },
    //毕业学校
    SchoolTagHandler(value){
        this.SchoolTagHint = value
    },
    //毕业证书PDF
    input1change(event) {
      var formdata = new FormData();
      formdata.append("studentname", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        console.log(res);
        if (res.status == 200) {
          // this.upname1 = 'https://res.qxueyou.com/' + res.data[0].path;
          this.upname1 = res.data[0].path;
        }
      });
    },
    //社保记录PDF
    input2change(event) {
      var formdata = new FormData();
      formdata.append("boxidentenfyfile", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        if (res.status == 200) {
          this.upname2 = res.data[0].path;
        }
      });
    },
    //工作经验PDF
    input3change(event) {
      var formdata = new FormData();
      formdata.append("socialfile", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        if (res.status == 200) {
          this.upname3 = res.data[0].path;
        }
      });
    },
    //身份证PDF
    input4change(event) {
      var formdata = new FormData();
      formdata.append("cardfile", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        if (res.status == 200) {
          this.upname4 = res.data[0].path;
        }
      });
    },
    //本人证件照JPG
    input5change(event) {
      var formdata = new FormData();
      formdata.append("photofile", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        if (res.status == 200) {
          // this.upname5 = 'https://res.qxueyou.com/' + res.data[0].path;
          this.upname5 = res.data[0].path;
        }
      });
    },
    //申报表zip格式
    input6change(event) {
      var formdata = new FormData();
      formdata.append("registrationForm", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        if (res.status == 200) {
          this.upname6 = res.data[0].path;
        }
      });
    },
    //学信网 ZIP格式
    input7change(event) {
      var formdata = new FormData();
      formdata.append("xuexinelectronic", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        if (res.status == 200) {
          this.upname7 = res.data[0].path;
        }
      });
    },
    //证书邮寄地址
    examCertificateChange(value){
        this.examCertificateHint = value
    },
    remarkChange(value){
      this.remarkHint = value
    },
    drag1() {
      console.log(this.$refs.fileName1)
      this.$refs.fileName1.click();
    },
    drag2() {
      this.$refs.fileName2.click();
    },
    drag3() {
      this.$refs.fileName3.click();
    },
    drag4() {
      this.$refs.fileName4.click();
    },
    drag5() {
      this.$refs.fileName5.click();
    },
    drag6() {
      this.$refs.fileName6.click();
    },
    drag7() {
      this.$refs.fileName7.click();
    },

    inputchange(event) {
      let file = event.target.files[0];
      // 创建表单对象
      var form = new FormData();

      //将文件放到表单对象中，一个key值可以对应多个value值
      form.append("file", file);

      this.fromdata = form;
      console.log(form);
    },
    inputclick() {
      this.$refs.fileName.click();
    },
    studentname() {
      this.status = 1;
      this.inputclick();
    },
    socalinfo() {
      this.$router.push({ path: "/social" });
    },
    //提交报名
    async owninfonext() {
      //传递的所有数据
      var logdata = {
        acceptance:this.acceptanceHint, //申报条件
        examRecord: this.examRecordHint, //文化程度
        examGetTime: this.examGetTimeHint, // 毕业时间
        schoolTag: this.SchoolTagHint, //毕业学校
        diploma: this.upname1, //上传毕业证书
        socialSecurity: this.upname2,  // 上传社保记录
        certificate: this.upname3, // 上传工作证明
        cardpositive: this.upname4, // 上传身份证
        examIdentificationImg: this.upname5,//  上传本人证件照
        registrationForm: this.upname6,//  上传报名申报表
        xuexinelectronic: this.upname7,//  上传学信网证件
        examCertificate: this.examCertificateHint, //证书邮寄地址
        remark:this.remarkHint, // 报名备注
        examOrderId:this.$route.query.examOrderId,
      };
      //验证必须的上传pdf
      var logdata1 = {
        diploma: this.upname1, //上传毕业证书
        certificate: this.upname3, // 上传工作证明
        cardpositive: this.upname4, // 上传身份证
        examIdentificationImg: this.upname5,//  上传本人证件照
        registrationForm: this.upname6,//  上传报名申报表
        xuexinelectronic: this.upname7,//  上传学信网证件
      };
      if (!Object.keys(logdata1).every(key => logdata1[key])) {
        Notify({ type: 'danger', message: '请先上传文件！' })
				return
			}
      this.$http.post(`ExamOrder/addExamOrder`, logdata).then((res) => {
        if(res.data.success == false){
          Dialog.alert({
            confirmButtonColor:'#54B0FB',
            title: '提示',
            message: res.data.msg,
          })
        }
        //驳回修改  跳转的页面
        if(res.data.data.amendmentNo==1 && res.data.success){
          this.$router.replace('/orderpaysuccee')
        }else{
           const params={
           examOrderId:res.data.data.examOrderId,
           subject:null
          }
          console.log(res)
            this.$http.post("trans/order/create",params).then((res) => {
              if (res.data.success) {
                const params={
                 orderId:res.data.data.id
                }
                this.$http.post("ExamOrder/orderParticulars",params).then((res) => {
                        this.$router.push({
                          path: "order_pinfo",
                          query: { transOrder: res.data.data.transOrder.id },
                        });
                      });
                
              }else{
                alert(res.data.data.msg)
              }
            });
        }
      
      });
    },

    //上传图片的7个函数
    diplomaHandler(){
      this.diplomaShow=true
      console.log('预览毕业证')
    },
    socialSecurityHandler(){
      this.socialSecurityShow=true
      console.log('预览社保记录')
    },
    workCertificateHandler(){
      this.workCertificateShow = true
      console.log('预览工作证明')
    },
    cardpositiveHandler(){
      this.cardpositiveShow=true
      console.log('预览身份证')
    },
    examIdentificationImgHandler(){
      this.examIdentificationImgShow=true
      console.log('证件照')
    },
    registrationFormHandler(){
      this.registrationFormShow=true
      console.log('申报表')
    },
    xuexinelectronicHandler(){
      this.xuexinelectronicShow=true
      console.log('学信网证件')
    },

  },
};
</script>

<style lang="less" scoped>
#app_p {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //   color: #2c3e50;
  //  font-size: 20px;

  width: 100%;
  height: 100vh;
}
.filenav {
  height: @minboxgao;
  padding: 0 @padingbox;
  line-height: @minboxgao;
  background: @backgroundcolor;
}
.own_name {
  height: @textgao;
  line-height: @textgao;
  margin-top: @padingboxmax;
  font-size: 30px;
  font-weight: 800;
  span{
    color: red;
  }
}
.own_contain {
  width: 100%;
  background: @whitee;
  margin: auto;
  box-sizing: border-box;
  padding: 0 @padingbox;
  overflow: auto;
}
.select_container {
  width: 100%;
  height: @minboxgao;

  margin-top: @padingboxmax;
  line-height: @minboxgao;
}
.select_container .select_r {
  position: absolute;
  right: 4px;
}
.fileboxbox {
  text-align: center;
}
.fileboxtext {
  color: #54b0fb;
}
.filetext {
  font-weight: 800;
  margin-top: @textgao;
  span{
    color: red;
  }
  .fileicon {
    color: @bluebtn;
  }
}
.filetext2 {
  margin: @textgao 0;
  color: @graycolor;
  font-size: 24px;

}
.filetext3{
  display: flex;
  .filetext3_right{
    width: 330px;
    height: 230px;
    background: #F6F7FA;
    border-radius: 6px;
    border: 1px solid #54B0FB;
    .filetext3_right_herd{
      display: flex;
      justify-content:space-between;
      width: 330px;
      height: 50px;
      background: #54B0FB;
      border-radius: 6px 6px 0px 0px;
      .eye{
        margin-right: 20px;
      }
      span{
        color:#FFFFFF
      }
      
    }
    .filetext3_right_main{
      justify-content: center;
      display: flex;
      height: 180px;
      width: 330px;
      background: #F6F7FA ;
      .filetext3_right_main_center{
        width: 127px;
        height: 179px;
        background: #FFFFFF;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.input-field  {
  border: 2px solid #dcdcdc;
  padding: 16px;
  margin-top: 46px;
  border-radius: 10px;
}
</style>
